import { SxProps, Theme } from '@mui/material';

const container: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '40px',
  pt: '10px'
};

const manageLink: SxProps<Theme> = {
  alignSelf: 'flex-start',
  fontSize: '14px'
};

const viewWorkflowLink: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  flexShrink: 0,
  fontSize: '16px',
  fontWeight: 700,
  whiteSpace: 'nowrap'
};

const linkIcon: SxProps<Theme> = {
  fontSize: '20px'
};

const liveVersionPill: SxProps<Theme> = {
  backgroundColor: 'successV2.light',
  color: 'successV2.main',
  borderRadius: '30px',
  px: '8px',
  py: '4px',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '20px',
  whiteSpace: 'nowrap'
};

const enrolledNames: SxProps<Theme> = {
  m: 0,
  mt: '14px',
  pl: '21px',
  listStyleType: 'disc'
};

export const addToWorkflowDrawerSx = {
  container,
  manageLink,
  viewWorkflowLink,
  linkIcon,
  liveVersionPill,
  enrolledNames
};
